<template lang="pug">
  .accounts-edit__container
    el-input(v-model="name")
    .control-bts__container
      el-button(type="success" :disabled="!name" size="mini" @click="startAddExchangeAggregatorUser()") Сохранить
      el-button(type="danger" size="mini" @click="resetAddExchangeAggregatorUser()") Отменить
</template>

<script>
import { mapActions } from 'vuex';
import { ADD_EXCHANGE_AGGREGATOR_USER } from "@/store/const/exchanges";
import instruments from "@/mixins/instruments";

export default {
  name: 'AddExchangeAggregatorUser',
  props: {
    group: { type: String, default: () => '' },
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      name: '',
    }
  },
  methods: {
    ...mapActions('exchanges', {
      addExchangeAggregatorUser: ADD_EXCHANGE_AGGREGATOR_USER,
    }),
    async startAddExchangeAggregatorUser() {
      this.$confirm(`Вы действительно хотите добавить пользователя ${this.name} в ${this.group}?`, 'Подтверждение').then(async () => {
        const request = await this.addExchangeAggregatorUser({
          group: this.group,
          name: this.name,
        });
        if (request.success) {
          this.$message.success('Изменение успешно');
          this.resetAddExchangeAggregatorUser();
        } else {
          this.$message.error(`Ошибка в изменении аккаунтов: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение отменено');
      });
    },
    resetAddExchangeAggregatorUser() {
      this.$emit('resetAddExchangeAggregatorUser');
    }
  }
};
</script>
<style scoped>
.control-bts__container {
    margin-top: 5px;
}
</style>
